import { Fab, Icon, Tooltip } from '@material-ui/core';
import React, { useEffect } from 'react';
import AutorenewRoundedIcon from '@material-ui/icons/AutorenewRounded';

function WorkflowItems({ label, value, name, handleFieldValue, fieldValues, disabled, ...otherProps }) {
    const [currentObj, setCurrentObj] = React.useState({});
    useEffect(() => {
        if (fieldValues && fieldValues['Users'] && (fieldValues['Users'] !== currentObj.Users ||
            (fieldValues['CurrentlyAssigned'] && fieldValues['CurrentlyAssigned'] !== currentObj.CurrentlyAssigned) ||
            (fieldValues['Futureworkflow'] && fieldValues['Futureworkflow'] !== currentObj.Futureworkflow))
            // && fieldValues['Future'] !== 'undefined'
        ) {
            if (typeof window.workflowObj !== "undefined") {
                window.workflowObj.data.findassignments(
                    fieldValues['Users'],
                    fieldValues['Role'],
                    fieldValues['CurrentlyAssigned'],
                    fieldValues['Futureworkflow'] === 'undefined' ? 'Y' : fieldValues['Futureworkflow'],
                    function (res) {
                        setCurrentObj(fieldValues)
                        handleFieldValue({ target: { value: res, name: name, checked: false } })
                    })
            }

        }
        // Your useEffect logic here
        // This code will run when the component mounts
        return () => {
            // Cleanup logic here
            // This code will run when the component unmounts   
            setCurrentObj({})

        };
    }, [fieldValues, fieldValues['Users']]);

    return (
        <div className='col-2 m-2'>
            <Tooltip title="Load Results" aria-label="Load Results">
                <Icon size="small" disabled={disabled} color="primary" onClick={() => handleFieldValue({ target: { value: value || null, name: name, checked: false } })}>
                    <AutorenewRoundedIcon fontSize="small" />
                </Icon>
            </Tooltip>
        </div>
    );
}

export default WorkflowItems;
